import type { FulfilmentStatus } from '@shared';
import { Badge } from '../ui/Badge';

/**
 * One badge for both halves of the manual side of the economy — a reward won on
 * a drop, and a credit pack someone asked to buy. They travel the same
 * Pending → Accepted → Delivered path, so a player learns to read one thing.
 *
 * Shared by the game and the owner console on purpose: the two must never
 * disagree about what a status looks like, or "delivered" means one thing on
 * the owner's screen and another on the player's.
 */
const CONFIG: Record<
  FulfilmentStatus,
  { tone: 'brand' | 'success' | 'warning' | 'neutral'; label: string; dot: boolean }
> = {
  pending: { tone: 'warning', label: 'Pending', dot: true },
  accepted: { tone: 'brand', label: 'Accepted', dot: true },
  delivered: { tone: 'success', label: 'Delivered', dot: false },
  cancelled: { tone: 'neutral', label: 'Cancelled', dot: false },
};

export function FulfilmentBadge({ status }: { status: FulfilmentStatus }) {
  const { tone, label, dot } = CONFIG[status];
  return (
    <Badge tone={tone} dot={dot}>
      {label}
    </Badge>
  );
}
